import { setUserInfoJson_filled } from "../store/actioncreator";
import {pyDB, dbRef, generateUUID} from "./pyDB";
//import Cookies from 'js-cookie';

//Set WebSocket URL and get Room ID
const wsURL = 'wss://' + window.location.hostname + ':8060/room/'; // PyDB Server Address
const urlparams = new URLSearchParams(window.location.search);
var roomId = urlparams.get("id"); //Room ID Parameter to Connect to
if(!roomId){roomId= "0";}
const connectionURL = wsURL+roomId;

function syncUrlParamsToLocalStorage() {
  if (typeof window === 'undefined') return; // Guard for non-browser envs

  const urlParams = new URLSearchParams(window.location.search);
  const paramsObj = {};
  const localStoreItems = { ...localStorage };

  for (const [key, value] of urlParams) {
    const storageKey = key === "id" ? "roomId" : key;
    paramsObj[storageKey] = value;
    localStorage.setItem(storageKey, value);
    //paramsObj[key] = value;
    //localStorage.setItem(key, value);
  }

  delete paramsObj["roomId"];
  delete paramsObj["name"];
  delete paramsObj["userId"];
  delete paramsObj["userID"]; //alte bezeichnung
  console.log("param hier, ", paramsObj);

  if(Object.keys(paramsObj).length === 0){
    console.log("param hier 2, ", localStoreItems);
    delete localStoreItems["roomId"];
    delete localStoreItems["name"];
    delete localStoreItems["userId"];
    delete localStoreItems["userID"]; //alte bezeichnung
    return localStoreItems;
  }

  return paramsObj;
}

// Call it when your app initializes (not at import time!)
const allParamsFromURL = syncUrlParamsToLocalStorage();
console.log("alle parameter der urlparams", allParamsFromURL);
const localStoreItems = { ...localStorage };
console.log("alle parameter der localstorage", localStoreItems);
export { allParamsFromURL };


/*
// exportiert alle Variablen von der url
export const allParamsFromURL = {};
for (const [key, value] of urlparams.entries()) {
  allParamsFromURL[key] = value;
}

//speichert alle variabeln der url im local storage
for (const [key, value] of urlparams) {
    localStorage.setItem(key, value);
}
*/

/*
function checkAndSetCookie(key, value){
  if(Cookies.get(key) || localStorage.getItem(key)){
    return true;
  } else {
    Cookies.set( key, value, { expires: 60 });
    localStorage.setItem(key, value);
    return false;
  }
}
*/  

//Init pyDB Connection
export const db = new pyDB(connectionURL);
export function getRoomId(){
  return db.roomId;
}

//Get Username + ID and save them
function getName(){
    let name = prompt("Bitte geben Sie Ihren Namen ein:");
    if(name==null || name.length<1){
      name= "Unbekannt";
    }
    localStorage.setItem("name", name);
    return name
}

var alternativeusername = null;
if(/*localStorage.getItem("userName")||*/ localStorage.getItem("name")){
  alternativeusername=/*localStorage.getItem("userName")||*/ localStorage.getItem("name");
/*} else if(Cookies.get("userName")){
  alternativeusername = Cookies.get("userName");*/
} else if(urlparams.get("name")){
  alternativeusername = urlparams.get("name");
  //Cookies.set("userName", alternativeusername, { expires: 60 });
  //localStorage.setItem("userName", alternativeusername);
  localStorage.setItem("name", alternativeusername);
}
export const userName = alternativeusername ?alternativeusername: getName();  //urlparams.get("name") ?urlparams.get("name") :getName();
/*
if(userName !== "Unbekannt"){
  checkAndSetCookie("userName", userName);
}
  */

//var alternativeID = Cookies.get("userID") ?Cookies.get("userID") :checkAndSetCookie("userID", generateUUID())
var alternativeID = null;
if(/*localStorage.getItem("userID")||*/ localStorage.getItem("userId")){
  alternativeID=/*localStorage.getItem("userID")||*/ localStorage.getItem("userId");
/*} else if(Cookies.get("userID")){
  alternativeID = Cookies.get("userID");*/
} else if(urlparams.get("userId")){
  alternativeID = urlparams.get("userId");
  /*Cookies.set("userID", alternativeID, { expires: 60 });*/
  //localStorage.setItem("userID", alternativeID);
  localStorage.setItem("userId", alternativeID);
} else {
  alternativeID = generateUUID();
  //localStorage.setItem("userID", alternativeID);
  localStorage.setItem("userId", alternativeID);
}

var real_userIdForDB = alternativeID; // urlparams.get("userId") ?urlparams.get("userId") : alternativeID;
/*if(!real_userIdForDB || real_userIdForDB.toString() === "0"){
  real_userIdForDB = generateUUID();
  //Cookies.set( "userID", real_userIdForDB, { expires: 60 });
  localStorage.setItem("userID", real_userIdForDB);
}*/
export const userIdForDB = real_userIdForDB;
//export const userIdForDB = urlparams.get("userId") ?urlparams.get("userId") : alternativeID;

//Open Database Connection and Reset URL with RoomID
export async function openNow(){
    await setUserInfoJson_filled();
    await db.open(()=>{
    if(roomId === "0" ){
        window.history.replaceState(null, "Meet", "?id=" + db.roomId);
    } else {
      db.roomId = roomId
      window.history.replaceState(null, "Meet", "?id=" + roomId);
    }
});
}



//Make a Database Reference for Root Path
export const databaseRootReference = new dbRef(db, []);